module.exports = "<input type=\"text\" class=\"{{cssClass}}\" [placeholder]=\"placeholder\" [(ngModel)]=\"inputValue\">\r\n"


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/debounce/debounce.component.html
// module id = ../../../../../src/app/shared/debounce/debounce.component.html
// module chunks = main